<template>
  <BaseModal
    :full-screen="isMobile"
    class="app-container"
    ui-refresh
    no-footer>
    <template #body>
      <h1>Outfit Builder</h1>
    </template>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/global/BaseModal.vue'
import useScreenSize from '@shared/composables/screenSize.js'

const { isMobile } = useScreenSize()
</script>

